<div class="c-auth">
  <div class="c-auth__wrapper">
    <div class="c-auth__form">
      <div class="brand-container">
        <img
          src="assets/img/logos/lightspeed-symbol.svg"
          class="c-auth__brand c-auth__brand-logo"
          alt="Lightspeed"
        />
        <img
          src="assets/img/logos/lightspeed-horizontal.svg"
          class="c-auth__brand"
          alt="Lightspeed"
        />
      </div>
      <div>
        <p class="c-auth__text">
          Welcome to Lightspeed Restaurant POS (L-Series)
        </p>
      </div>

      <div *ngIf="success" class="o-flash o-flash--success">{{ success }}</div>

      <ng-container *ngIf="!success">
        <form
          *ngIf="usernameForm"
          [formGroup]="usernameForm"
          (submit)="usernameFormSubmit()"
          id="usernameForm"
          #ngUsernameForm="ngForm"
          [ngClass]="{ submitted: ngUsernameForm.submitted }"
        >
          <ls-cr-field-wrapper
            label="Username"
            [invalid]="usernameForm.get('username').invalid"
          >
            <input
              cr-input
              autofocus
              type="username"
              formControlName="username"
            />
            <span
              field-errors
              *ngIf="
                usernameForm.get('username').errors?.required &&
                ngUsernameForm.submitted
              "
              >This field is required.
            </span>
          </ls-cr-field-wrapper>

          <div class="c-form__button">
            <button
              class="o-button o-button--success resetButtonStyle"
              type="submit"
              variant="primary"
              buttonType="fill"
              i18n="Reset Password|Button to rest password @@buttonReset"
            >
              Reset
            </button>
          </div>
        </form>

        <form
          *ngIf="passwordForm"
          [formGroup]="passwordForm"
          (submit)="passwordFormSubmit()"
          id="passwordForm"
          #ngPasswordForm="ngForm"
          [ngClass]="{ submitted: ngPasswordForm.submitted }"
        >
          <p
            *ngIf="forced"
            i18n="Reset Password|Details @@resetPasswordDetails"
            class="u-align-center"
          >
            Your password has expired. Please choose a new password.
          </p>

          <br />
          <ls-cr-field-wrapper
            *ngIf="forced"
            label="Old password"
            [invalid]="passwordForm.get('oldPassword').invalid"
            size="large"
          >
            <input
              cr-input
              autofocus
              type="password"
              formControlName="oldPassword"
            />
            <span
              field-errors
              *ngIf="
                passwordForm.get('oldPassword').errors?.required &&
                ngPasswordForm.submitted
              "
              >This field is required.
            </span>
          </ls-cr-field-wrapper>

          <ls-cr-field-wrapper
            label="New password"
            [invalid]="passwordForm.get('password').invalid"
            size="large"
          >
            <input cr-input type="password" formControlName="password" />
            <span
              field-errors
              *ngIf="
                passwordForm.get('password').errors?.required &&
                ngPasswordForm.submitted
              "
              >This field is required.
            </span>
            <span
              field-errors
              *ngIf="
                passwordForm.get('password').errors?.wrongPasswordPolicy &&
                ngPasswordForm.submitted
              "
            >
              Password must contain 8 characters including at least one upper,
              one lower, one special character and one digit.</span
            >
          </ls-cr-field-wrapper>

          <ls-cr-field-wrapper
            label="Confirm password"
            [invalid]="passwordForm.get('confirmPassword').invalid"
            size="large"
          >
            <input cr-input type="password" formControlName="confirmPassword" />
            <span
              field-errors
              *ngIf="
                passwordForm.get('confirmPassword').errors?.required &&
                ngPasswordForm.submitted
              "
              >This field is required.
            </span>
            <span
              field-errors
              *ngIf="
                passwordForm.get('confirmPassword').dirty &&
                passwordForm.get('confirmPassword').errors?.passwordDifferences
              "
            >
              Passwords don't match.
            </span>
          </ls-cr-field-wrapper>
          <div class="c-form__button">
            <button
              class="o-button resetButtonStyle"
              type="submit"
              variant="primary"
              buttonType="fill"
              i18n="Reset Password|Button to rest password @@buttonReset"
            >
              Reset
            </button>
          </div>
        </form>
        <div *ngIf="error" class="o-flash o-flash--danger">{{ error }}</div>
      </ng-container>
    </div>
  </div>
</div>

<!-- dynamic translations -->
<div
  ls-dynamic-translation
  id="Something went wrong. Please try again or contact Support."
  i18n="ResetPassword|genric error @@errorResetPasswordSomethingWentWrong"
>
  Something went wrong. Please try again or contact Support.
</div>
<div
  ls-dynamic-translation
  id="Passwords are not matching."
  i18n="ResetPassword|error when passwords are not matching @@errorResetPasswordNonMatchingPassword"
>
  Passwords are not matching.
</div>
<div
  ls-dynamic-translation
  id="Please fill in the password fields."
  i18n="ResetPassword|error when password is not filled in @@errorResetPasswordNoPassword"
>
  Please fill in the password fields.
</div>
<div
  ls-dynamic-translation
  id="Please fill in a username."
  i18n="ResetPassword|error when username is not filled in @@errorResetPasswordNoUsername"
>
  Please fill in a username.
</div>
<div
  ls-dynamic-translation
  id="Your password has been reset successfully! You can now login with your new password."
  i18n="ResetPassword|success message when password has been reset @@successMessageResetPassword"
>
  Your password has been reset successfully! You can now login with your new
  password.
</div>
<div
  ls-dynamic-translation
  id="An email has been sent to you and should arrive shortly with password reset instructions. Please visit your email and click the provided link."
  i18n="ResetPassword|message with reset password instructions @@instructionMessageResetPassword"
>
  An email has been sent to you and should arrive shortly with password reset
  instructions. Please visit your email and click the provided link.
</div>
